import "./signature.css";
import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {setPersonalData} from "../../../redux/personal_store";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";
import axios from "axios";
import {setOwnerData} from "../../../redux/owner_info_store";

function Signature({personalData, appData, ownerData, setPersonalData}) {
    let backTo = '/review'
    if (appData.sub_account_type === 'omnibus') backTo = '/personal'

    const {t} = useTranslation();
    const navigate = useNavigate();

    const [signature, setSignature] = useState({
        fullName: "",
        ownerFullName: "",
        clientIP: ""
    });

    const [signatureErrors, setSignatureErrors] = useState({
        fullName: "",
        ownerFullName: "",
    });

    useEffect(() => {
        setSignature((prevSignature) => ({
            ...prevSignature,
            fullName: "",
        }));
    }, [personalData.firstName, personalData.middleName, personalData.lastName]);

    useEffect(() => {
        setSignature((prevSignature) => ({
            ...prevSignature,
            ownerFullName: "",
        }));
    }, [ownerData.joint_first_name, ownerData.joint_middle_name, ownerData.joint_last_name]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setSignatureErrors({
            fullName: "",
            ownerFullName: "",
        });

        let isValid = true;

        const fullName = personalData.middleName ? `${personalData.firstName} ${personalData.middleName} ${personalData.lastName}` : `${personalData.firstName} ${personalData.lastName}`

        const lowerCaseFullName = fullName.toLowerCase();
        const lowerCaseSignature = signature.fullName ? signature.fullName.toLowerCase() : "";

        const lowerOwnerCaseSignature = signature.ownerFullName ? signature.ownerFullName.toLowerCase() : "";

        const ownerfullName = ownerData.joint_middle_name ? `${ownerData.joint_first_name} ${ownerData.joint_middle_name} ${ownerData.joint_last_name}` : `${ownerData.joint_first_name} ${ownerData.joint_last_name}`
        const lowerOwnerCaseFullName =ownerfullName.toLowerCase();

        if (!lowerCaseSignature) {
            setSignatureErrors((prevErrors) => ({
                ...prevErrors,
                fullName: t("errors.required_field"),
            }));
            isValid = false;
        } else {
            if (lowerCaseSignature !== lowerCaseFullName) {
                setSignatureErrors((prevErrors) => ({
                    ...prevErrors,
                    fullName: `${t("errors.invalid_signature")} ${fullName}`,
                }));
                isValid = false;
            }
        }

        if (appData.account_type === "joint") {
            if (!lowerOwnerCaseSignature) {
                setSignatureErrors((prevErrors) => ({
                    ...prevErrors,
                    ownerFullName: t("errors.required_field"),
                }));
                isValid = false;
            } else {
                if (lowerOwnerCaseSignature !== lowerOwnerCaseFullName) {
                    setSignatureErrors((prevErrors) => ({
                        ...prevErrors,
                        ownerFullName: `${t("errors.invalid_signature")} ${ownerfullName}`,
                    }));
                    isValid = false;
                }
            }
        }


        if (!personalData || !ownerData) {
            return null;
        }

        if (isValid) {
            setPersonalData(personalData);
            if (!appData.app_id) alert("Missing app id");

            try {
                await updateSignatureValues();
                navigate("/welcome-to");
            } catch(error) {
                setSignatureErrors((prevErrors) => ({
                    ...prevErrors,
                    submitError: error.message,
                }));
            }
        }
    };

    const getClientIP = async () => {
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            return data.ip; // Return just the IP address
        } catch (error) {
            console.error(error);
            return null; // Return null in case of an error
        }
    };

    const getSignatureValues = () => {
        return {
            SignatureName: signature.fullName,
            OwnerName: signature.ownerFullName,
        };
    };
    const updateSignatureValues = async () => {
        const clientIP = await getClientIP();

        if (!clientIP) {
            console.error("Failed to retrieve client IP");
            return;
        }

        const URL = `${process.env.REACT_APP_API_URL}/api/accounts/step7/` + appData.app_id;
        const params = getSignatureValues();
        params.signature_ip = clientIP;

        try {
            const response = await axios.put(URL, params, {
                headers:  {
                    "Access-Control-Allow-Origin": "*",
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json",
                },
            });
            if (response.data && response.data.status && ['404', '500'].includes(response.data.status)) {
                throw new Error(response.data.message || 'Unknown error occurred');
            }

        } catch (error) {
            throw error;
        }
    };

    return (
        <div className="signature">
            <Logout/>
            <p className="sign_and_submit_heading">{t("signature.sign_and_submit")}</p>
            <p className="heading_content">
                {t("signature.terms_and_conditions")}
                <a
                    style={{color: "unset", textDecoration: "underline"}}
                    href="https://www.choicetrade.com/legal.php?page=RiskDisclosure"
                    target="_blank"
                    rel="noreferrer"
                >
                    {t("signature.risk_disclosure_statement")}
                </a>
                {t("signature.service_fee")}
            </p>
            <p className="heading_content">{t("signature.arbitration_agreement")}</p>

            <form onSubmit={handleSubmit} style={{marginTop: "5%"}}>
                <div className="signatures">
                    <div>
                        <p className="heading_content">
                            {t("signature.primary_account")} {t("signature.signature")}
                        </p>
                        <div className="signature_message">
                            <p className="signature_message_text">{t("signature.signature_line")}</p>
                        </div>
                        <div style={{textAlign: "center"}}>
                            <input
                                type="text"
                                placeholder={`${personalData.firstName} ${personalData.middleName} ${personalData.lastName}`}
                                className="signature_input"
                                name="fullName"
                                value={signature.fullName}
                                onChange={(e) => {
                                    setSignature((prevSignature) => ({...prevSignature, fullName: e.target.value}));
                                }}
                            />
                            {signatureErrors.fullName &&
                                <p className="signature_info_error">{signatureErrors.fullName}</p>}
                        </div>
                    </div>

                    {appData.account_type === "joint" &&
                        <div>
                            <p className="heading_content">Joint Owner signature:</p>
                            <div className="signature_message">
                                <p className="signature_message_text">{t("signature.signature_line")}</p>
                            </div>
                            <div style={{textAlign: "center"}}>
                                <input
                                    type="text"
                                    placeholder={`${ownerData.joint_first_name} ${ownerData.joint_middle_name} ${ownerData.joint_last_name}`}
                                    className="signature_input"
                                    name="ownerFullName"
                                    value={signature.ownerFullName}
                                    onChange={(e) => {
                                        setSignature((prevSignature) => ({
                                            ...prevSignature,
                                            ownerFullName: e.target.value
                                        }));
                                    }}
                                />
                                {signatureErrors.ownerFullName &&
                                    <p className="signature_info_error">{signatureErrors.ownerFullName}</p>}
                            </div>
                        </div>
                    }
                </div>

                <div className="signature_btn">
                    <Link style={{textDecoration: "none"}} to={backTo}>
                        <button className="signature_back_btn">{t("back_btn")}</button>
                    </Link>
                    <button className="signature_continue_btn" type="submit">
                        {t("next_btn")}
                    </button>
                </div>
                <div>
                    {signatureErrors.submitError && (
                        <div style={{ color: 'red', textAlign: "center" }}>
                            {signatureErrors.submitError}
                        </div>
                    )}
                </div>
            </form>
        </div>
    );
}

const mapStateToProps = (state) => ({
    personalData: state.personalData,
    appData: state.appData,
    ownerData: state.ownerData
});

const mapDispatchToProps = {
    setPersonalData,
    setOwnerData
};

export default connect(mapStateToProps, mapDispatchToProps)(Signature);